import * as React from 'react';
import moment from 'moment';

import { ICalendarState, IMonth, IDay } from '../../classes/calendar';
import { connect, Dispatch } from 'react-redux';
import { ICalendarAppState } from '../../redux-state';
import { nextMonth } from '../../redux-state/actions/calendar.actions';
import { ICalendarAppText } from '../../redux-state/interfaces/text/calendar-app.text';
import NextMonthView from './month-selection-load-more.view';

interface ILoadMoreExternalProps {
}

interface StateToProps {
    text: ICalendarAppText;
    currDate: moment.Moment;
    lastDate: moment.Moment;
}

interface DispatchToProps {
    goToNextMonth: () => void;
}

export type LoadMoreProps = ILoadMoreExternalProps & StateToProps & DispatchToProps;

export class LoadMoreBase extends React.Component<LoadMoreProps, any> {
    render() {
        return (
            <>
                {
                    this.props.currDate.clone().endOf("month").isSameOrBefore(this.props.lastDate) ? <NextMonthView {...this.props} /> : null
                }
            </>
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: ILoadMoreExternalProps): StateToProps {
    return {
        text: state.calendarText,
        currDate: state.calendar.currentDate,
        lastDate: state.calendarSettings.monthsOnCalendar[state.calendarSettings.monthsOnCalendar.length - 1] || moment()
    }
}

function mapDispatchToProps(dispatch: Dispatch): DispatchToProps {
    return {
        goToNextMonth: () => dispatch(nextMonth())
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(LoadMoreBase);